// src/services/regions.js

export const REGIONS = {
  us: {
    label: "United States / Global",
    workspaceUrl: "https://app.snoooz.ai",
    sessionUrl: import.meta.env.VITE_SNOOOZ_SESSION_URL_US,
    requestCodeUrl: import.meta.env.VITE_SNOOOZ_REQUEST_CODE_URL_US,
    verifyCodeUrl: import.meta.env.VITE_SNOOOZ_VERIFY_CODE_URL_US,
    createDraftUrl: import.meta.env.VITE_SNOOOZ_CREATE_DRAFT_URL_US,
    templatesUrl: import.meta.env.VITE_SNOOOZ_TEMPLATES_URL_US,
    improveEmailUrl: import.meta.env.VITE_SNOOOZ_IMPROVE_EMAIL_URL_US
  },
  eu: {
    label: "European Union",
    workspaceUrl: "https://app-eu.snoooz.ai",
    sessionUrl: import.meta.env.VITE_SNOOOZ_SESSION_URL_EU,
    requestCodeUrl: import.meta.env.VITE_SNOOOZ_REQUEST_CODE_URL_EU,
    verifyCodeUrl: import.meta.env.VITE_SNOOOZ_VERIFY_CODE_URL_EU,
    createDraftUrl: import.meta.env.VITE_SNOOOZ_CREATE_DRAFT_URL_EU,
    templatesUrl: import.meta.env.VITE_SNOOOZ_TEMPLATES_URL_EU,
    improveEmailUrl: import.meta.env.VITE_SNOOOZ_IMPROVE_EMAIL_URL_EU
  }
};